import cardsStyle from '../../styles/components/cards';

const style = () => ({
  usersTable__table: {
    'height': 'calc(100vh - 250px)',
    '@media (max-width: 640px)': {
      height: 'calc(100vh - 360px)',
    },
  },
  usersTable__tbodyInfinite: {
    display: 'block',
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: 'calc(100vh - 275px)',
    minWidth: 'max-content',
  },
  tbodyInfinite_noItems: {
    height: 'calc(100vh - 275px)',
  },
  usersTable__tbodyInfinite_noControls: {
    maxHeight: 'calc(100vh - 180px)',
  },
  usersTableCard: {
    ...cardsStyle.card,
    // height: 'calc(100vh - 99px)',
  },
  usersTableCard__header: {
    ...cardsStyle.card__header,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '15px',
    padding: '15px 20px',
  },
  usersTableCard__additionalHeaderActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'end',
  },
  usersTableCard__multiselectOptions: {
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
  },
  usersTableCard__title: {
    ...cardsStyle.card__title,
    ...cardsStyle.card__title_primary,
    borderBottom: 'none',
  },
  usersTableCard__content: {
    ...cardsStyle.card__content,
    padding: '0px 20px 5px 20px !important',
  },
  usersTableCard__action: {
    ...cardsStyle.card__action,
    width: '100%',
  },
});

export default style;
